
import _ from 'lodash';
import apiBaseUrl from '../../apiBaseUrl';

const namespaced = true;

const state = {
  isDemoApp: window.location.href.indexOf(`.demo.`) !== -1,
  isLocalApp: window.location.href.indexOf(`localhost`) !== -1 || window.location.href.indexOf(`.b2d.sh`) !== -1,
  baseUrl: `/`,
  slug: null,
  apiBaseUrl: `/api/`,
  routerTitle: `Indeego`,
  rawTabs: [
    { id: 1, label: `Accueil`, href: `/`, enable: (user, company) => company.isRoot && ((user.client.id === company.id && user.clientAdmin) || user.isIndeego) }, //eslint-disable-line
    { id: 2, label: `Tickets`, href: `/ticket` },
    { id: 3, label: `Clients`, href: `/client`, enable: (user, company) => company.isRoot && ((user.client.id === company.id && user.clientAdmin) || user.isIndeego) }, //eslint-disable-line
    { id: 5, label: `Administration`, href: `/administration`, enable: (user, company) => company.isRoot && ((user.client.id === company.id && user.role === `administrator`) || user.isIndeego) }, //eslint-disable-line
    { id: 6, label: `Sites`, href: `/mysite`, enable: (user, company) => !company.isRoot && user.clientAdmin }, //eslint-disable-line
    { id: 7, label: `Utilisateurs`, to: `/users`, enable: (user, company) => (company.isRoot || company.slug.length) && (user.clientAdmin || user.isIndeego) }, //eslint-disable-line
  ],
  snackbar: {
    isOpened: false,
    color: ``,
    message: ``,
    timeout: 3500,
  },
  areInitialDatasFetched: false,
  forceDeviceTooSmall: false,
  searchResultsInterventions: [],
  searchTextInterventions: null,
  countInboxInterventionsInterval: null,
  countInboxRecurrentInterventions: 0,
  countInboxOnlineInterventions: 0,
};

const mutations = {
  SET_ROUTER_TITLE(state, title) {
    state.routerTitle = title;
  },
  SET_URL_INFOS(state, { baseUrl, slug, apiBaseUrl }) {
    state.baseUrl = baseUrl;
    state.slug = slug;
    state.apiBaseUrl = apiBaseUrl;
  },
  SET_ARE_INITIAL_DATAS_FETCHED(state, areInitialDatasFetched) {
    state.areInitialDatasFetched = areInitialDatasFetched;
  },
  SHOW_SNACKBAR(state, props) {
    state.snackbar = _.clone({
      ...state.snackbar,
      isOpened: false,
    });
    setTimeout(() => {
      state.snackbar = _.clone({
        ...state.snackbar,
        ...props,
        isOpened: true,
      });
    });
  },
  SET_FORCE_DEVICE_TOO_SMALL(state, forceDeviceTooSmall) {
    state.forceDeviceTooSmall = forceDeviceTooSmall === true;
  },
  SET_SEARCH_RESULTS_INTERVENTIONS(state, interventions) {
    state.searchResultsInterventions = interventions;
  },
  SET_SEARCH_TEXT_INTERVENTIONS(state, searchText) {
    state.searchTextInterventions = searchText;
  },
  CLEAR_COUNT_INBOX_INTERVENTION_INTERVAL(state) {
    clearInterval(state.countInboxInterventionsInterval);
  },
  SET_COUNT_INBOX_INTERVENTION_INTERVAL(state, countInboxInterventionsInterval) {
    state.countInboxInterventionsInterval = countInboxInterventionsInterval;
  },
  SET_COUNT_INBOX_RECURRENT_INTERVENTIONS(state, countInboxRecurrentInterventions) {
    state.countInboxRecurrentInterventions = countInboxRecurrentInterventions;
  },
  SET_COUNT_INBOX_ONLINE_INTERVENTIONS(state, countInboxOnlineInterventions) {
    state.countInboxOnlineInterventions = countInboxOnlineInterventions;
  },
};

const actions = {
  loadUrlInfos({ commit }) {
    const baseUrl = window.location.href.replace(/https?:\/\//, ``).split(`/`)[0];
    const slug = baseUrl.split(`.`)[0];
    commit(`SET_URL_INFOS`, { baseUrl, slug, apiBaseUrl });
  },
  showSnackbar: {
    root: true,
    handler({ commit }, props) {
      commit(`SHOW_SNACKBAR`, props);
    },
  },
  async searchInterventions({ dispatch, commit, state }, searchText) {
    commit(`SET_SEARCH_TEXT_INTERVENTIONS`, searchText);
    const interventions = await dispatch(`model/intervention/search`, searchText, { root: true });

    if (state.searchTextInterventions === searchText) {
      commit(`SET_SEARCH_RESULTS_INTERVENTIONS`, interventions);
    }
  },
  initCountInboxInterventions({
    commit, dispatch, getters, rootGetters,
  }) {
    commit(`CLEAR_COUNT_INBOX_INTERVENTION_INTERVAL`);
    const canPlanInbox = rootGetters[`model/client/getPlanRight`](`inbox`);
    if (getters.canSeeInbox && canPlanInbox) {
      clearInterval(this.countInboxInterventionsInterval);
      dispatch(`fetchCountInboxInterventions`);
      const countInboxInterventionsInterval = setInterval(() => {
        dispatch(`fetchCountInboxInterventions`);
      }, 60000);
      commit(`SET_COUNT_INBOX_INTERVENTION_INTERVAL`, countInboxInterventionsInterval);
    }
  },
  async fetchCountInboxInterventions({ dispatch, commit, rootState }) {
    try {
      const makerId = rootState[`model/client`].company.id;
      const { countRecurrent, countOnline } = await dispatch(`model/inboxIntervention/countForMaker`, makerId, { root: true });
      commit(`SET_COUNT_INBOX_RECURRENT_INTERVENTIONS`, countRecurrent);
      commit(`SET_COUNT_INBOX_ONLINE_INTERVENTIONS`, countOnline);
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {
  tabs(state, getters) {
    return state.rawTabs.map(tab => ({
      ...tab,
      href: `${getters.baseUrl}${tab.href}`,
      enable: tab.enable || (() => true),
    }));
  },
  canSeeInbox(state, getters, rootState) {
    const clientModelState = rootState[`model/client`];
    const userModelState = rootState[`model/user`];
    return (
      (
        (clientModelState.isMaker && userModelState.isMakerUser)
        || (clientModelState.isSelfMaker && userModelState.isSelfMakerUser)
      )
      && userModelState.isAdmin
    );
  },
  isGlobalApp: state => state.slug === `app`,
  hasInboxInterventions: (state, getters) => getters.hasInboxRecurrentInterventions || getters.hasInboxOnlineInterventions,
  hasInboxRecurrentInterventions: state => state.countInboxRecurrentInterventions > 0,
  hasInboxOnlineInterventions: state => state.countInboxOnlineInterventions > 0,
  countInboxRecurrentInterventions: state => state.countInboxRecurrentInterventions,
  countInboxOnlineInterventions: state => state.countInboxOnlineInterventions,
  countInboxInterventions: (state, getters) => getters.countInboxRecurrentInterventions + getters.countInboxOnlineInterventions,
};

export default {
  namespaced, state, mutations, actions, getters,
};
